import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CATEGORY_LABELS } from "../data/content";

const ProjectCard = ({ project, className = "" }) => (
  <Link
    to={`/realisations/${project.slug}`}
    data-testid={`project-card-${project.slug}`}
    className={`group relative block overflow-hidden bg-bati-mist ${className}`}
  >
    <div className="aspect-[4/3] w-full overflow-hidden">
      <img
        src={project.cover_image}
        alt={project.title}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
      />
    </div>
    <span className="absolute left-4 top-4 bg-white/95 px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.12em] text-bati-blue">
      {CATEGORY_LABELS[project.category] || project.category}
    </span>
    {project.example && (
      <span className="absolute right-4 top-4 bg-bati-ink/70 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-white/85">
        Visuel d'illustration
      </span>
    )}
    <div className="pointer-events-none absolute inset-x-0 bottom-0 translate-y-2 bg-gradient-to-t from-black/85 via-black/40 to-transparent p-5 pt-16 opacity-90 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
      <h3 className="font-display text-xl font-bold leading-tight text-white">{project.title}</h3>
      <p className="mt-1.5 text-[13px] font-medium text-white/75">
        {project.city} — {project.work_types}
      </p>
    </div>
    <span className="absolute bottom-5 right-5 grid h-9 w-9 translate-y-2 place-items-center bg-bati-sky text-white opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
      <ArrowUpRight className="h-4 w-4" />
    </span>
  </Link>
);

export default ProjectCard;
